<template>
    <v-menu
        :position-x="position.x"
        :position-y="position.y"
        v-model="visible"
        absolute
        offset-y
        >
        <v-list dense>
            <v-list-item
                v-for="item in items"
                :key="item.title"
                :disabled="item.disabled"
                link
                @click="emitClicked(item.action)">
                <v-list-item-icon >
                    <v-icon :disabled="item.disabled">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    {{  item.title }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "ContextMenu",
    props: {
        items: {
            type: Array,
            required: true
        },
        position: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            visible: true
        }
    },
    methods: {
        emitClicked(action) {
            this.$emit("contextmenu:click", action)
        }
    }
}
</script>